/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90fbd5da1cedf8ab72cfec6643bf73aa>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/subtasks
 * Usage guidance:
 * Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SubtasksIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "SubtasksIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SubtasksIcon.displayName = 'SubtasksIcon';
var _default = exports.default = SubtasksIcon;